import { buildCssClassName, getTransitionTwClasses } from "@/3514/utils"

import { EAccordionBordersVariant, EAccordionColorVariant } from "./accordion.types"

const headerColorsMap: {
    [V in EAccordionColorVariant]: (params: {
        isExpanded: boolean
        isExpandable: boolean
        withHover: boolean
    }) => string
} = {
    [EAccordionColorVariant.Accent]: (params: {
        isExpanded: boolean
        isExpandable: boolean
        withHover: boolean
    }): string =>
        buildCssClassName(
            "bg-white",
            "border-accent",
            { "focus-within:bg-blue-600": import.meta.env.PROD },
            { "focus-within:bg-blue-500": import.meta.env.DEV },
            { "hover:border-accent hover:bg-blue-600": params.withHover },
            "focus-within:border-accent",
            "group:border-accent",
            "group-focus-visible:border-accent",
            "group-focus:border-accent",
            [params.isExpandable && { "border-b-blue-500": params.isExpanded }],
            getTransitionTwClasses("all", 200)
        ),
    [EAccordionColorVariant.White]: (params: {
        isExpanded: boolean
        isExpandable: boolean
        withHover: boolean
    }): string =>
        buildCssClassName(
            "bg-white",
            "border-blue-400",
            { "focus-within:bg-blue-600": import.meta.env.PROD },
            { "focus-within:bg-blue-500": import.meta.env.DEV },
            { "hover:border-blue-300 hover:bg-blue-600": params.withHover },
            "focus-within:border-blue-300",
            "group:border-blue-300",
            "group-focus-visible:border-blue-300",
            "group-focus:border-blue-300",
            [params.isExpandable && { "border-b-blue-500": params.isExpanded }],
            getTransitionTwClasses("all", 200)
        ),
    [EAccordionColorVariant.WhiteMuted]: (params: {
        isExpanded: boolean
        isExpandable: boolean
        withHover: boolean
    }): string =>
        buildCssClassName(
            "bg-blue-600",
            "border-transparent",
            [params.isExpandable && { "border-b-blue-500": params.isExpanded }],
            getTransitionTwClasses("all", 200)
        ),
    [EAccordionColorVariant.Orange]: (params: {
        isExpanded: boolean
        isExpandable: boolean
        withHover: boolean
    }): string =>
        buildCssClassName(
            "bg-white",
            "border-red-300",
            { "focus-within:bg-red-600": import.meta.env.PROD },
            { "focus-within:bg-red-500": import.meta.env.DEV },
            { "hover:border-red-200 hover:bg-red-600": params.withHover },
            "focus-within:border-red-200",
            "group:border-red-200",
            "group-focus-visible:border-red-200",
            "group-focus:border-red-200",
            [params.isExpandable && { "border-b-red-500": params.isExpanded }],
            getTransitionTwClasses("all", 200)
        )
}

const headerBordersMap: { [B in EAccordionBordersVariant]: string } = {
    [EAccordionBordersVariant.Bordered]: "border-[3px]",
    [EAccordionBordersVariant.ThinBordered]: "border-[1px]",
    [EAccordionBordersVariant.NoBordered]: "border-[0px]"
}

export default { headerColorsMap, headerBordersMap }
